import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { checkStatus } from '../../../../util/util';
import ModalAddIO from '../../../Modals/ModalAddIO';
import ModalConfirmUserInformation from '../../../Modals/ModalConfirmUserInformation';
import AlertBar from '../../../Modals/AlertBar';
import {AlertConfirm, AlertCommit} from '../../../Modals/AlertBar';

class InputOutputDevice extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: '',
            portTypeList: '',
            portNo: 0,
            portCatg: '',
            porTypeNo: '',
            port_type: '',
            port_no: 0,
            name: '',
            val_name0: '',
            command_id0: 0,
            val_name1: '',
            command_id1: 0,
            portList: [],
            inputOutputList: [],
            typeNoList: [],
            inputOutputListObj: [],
            commandList:[],
            isAddIO: false,
            showModalConfirmAddAD: false,
            notification: false
        }
    }

    componentWillMount() {
        // const { inputOutputs } = this.props;
        // this.setState({
        //     inputOutputListObj: inputOutputs,
        // });
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.inputOutputs !== this.props.inputOutputs ) {

            let inputOutputs = nextProps.inputOutputs;
            this.setState({
                inputOutputList: inputOutputs,
                inputOutputListObj: inputOutputs
            });
        }
    }

    componentDidMount(){
        this.getDevicePortList();
        this.getDeviceCommandList();
    }
    componentWillUnmount(){

    }

    getDevicePortList(){

        const { user_id, user_name,token } = this.props;
        fetch(`http://203.150.199.244/api/admin/getDevicePortList/IO`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({})
            })
            .then(response => { return checkStatus(response)})
            .then(data => {
                let portList = [];
                data.RESULT_DATA.map((port,key) => {
                    portList.push({
                        id: port._id,
                        portTypeList: port.port_type,
                        portNo: port.port_no,
                        portCatg: port.port_catg,
                        porTypeNo: port.port_type+' '+port.port_no
                    });

                });
                this.setPortList(portList);

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    setPortList(data){

        this.setState({
            portList:data,
        });
    }

    getDeviceCommandList(){

        const { user_id, user_name,token } = this.props;
        fetch(`http://203.150.199.244/api/admin/getCommandList`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({})
            })
            .then(response => { return checkStatus(response)})
            .then(data => {
                let commandList = [];
                data.RESULT_DATA.map((command,key) => {
                    commandList.push({
                        command_id:command.command_id,
                        command_name:command.command_name

                    });

                });
                this.setCommandList(commandList);

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    setCommandList(data){

        this.setState({
            commandList:data,
        });
    }

    onChangeSelectedPort(e, key){
        const { inputOutputListObj } = this.state;

        if (e.target.name === 'port') {
            const str = e.target.value;
            const res = str.split(" ");
            inputOutputListObj[key]['port_type'] = res[0] === '--ไม่มี--' ? '' : res[0];
            inputOutputListObj[key]['port_no'] = res[1] || '';
            this.setState({ inputOutputListObj });
        } else {
            inputOutputListObj[key][e.target.name] = e.target.value;
            this.setState({ inputOutputListObj });
        }
    }

    onChangeSelectedCommand(e, key){
        const { inputOutputListObj } = this.state;

        inputOutputListObj[key][e.target.name] = e.target.value;
        this.setState({ inputOutputListObj });

    }

    // onClickSubmitIO = () => {
    //     const { inputOutputListObj } = this.state;
    //     // this.setState({ showModalConfirmAddIO: true });
    // }

    onClickAddIO() {
        this.setState({ isAddIO: true});
    }

    onClickConfirmAddIO(obj) {
        const { inputOutputList } = this.state;
        // this.setState({ objFromAddIO: obj, isAddIO: false });
        this.setState({ isAddIO: false });
        inputOutputList.push(obj);
    }

    onClickDeleteRowIO(key) {
        const { inputOutputList } = this.state;
        inputOutputList.splice(key, 1);
        this.setState({ inputOutputList });
    }

    onClickCancelAddIOs = (status) => {
        this.setState({ showModalConfirmAddIO: status });
    }

    onClickSubmitIO = () => {

        AlertConfirm("แก้ไขข้อมูล Input/Output"," ").then(isOk=>{
            if(isOk){
                const {
                    user_name,
                    user_id,
                    user_ids,
                    token
                } = this.props;
                const { inputOutputListObj } = this.state;

                fetch(`http://203.150.199.244/api/admin/updateDevice/${user_ids}`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        // "user_id": user_id,
                        // "user_name": user_name,
                        "token": token
                    },
                    body: JSON.stringify({
                        "input_outputs" : inputOutputListObj
                    })
                })
                .then(response => response.json())
                .then((data) => {

                    if(data.RESULT_STATUS == "000")
                    AlertCommit(true,"บันทึกข้อมูลเรียบร้อยแล้ว");
                else{
                    AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                }
                        this.setState({
                            // showModalConfirmAddIO: false,
                            isAddIO: false,
                            // notification: true
                        })
                    }).catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });

            }

        });


    }

    render(){
        const {
            portList,
            inputOutputList,
            commandList,
            isAddIO,
            showModalConfirmAddIO,
            notification
        } = this.state;
        return(
                <div className="container-fluid">
                    { notification &&
                    <AlertBar />
                    }

                <div className="card">
                        <h5 className="card-header">Input/Output</h5>
                        <div className="card-body">
                        {
                        isAddIO &&
                        <ModalAddIO
                            portList={portList}
                            commandList={commandList}
                            onClickCancelAddIO={() => this.setState({ isAddIO: false })}
                            onClickConfirmAddIO={(data) => this.onClickConfirmAddIO(data)}
                        />
                    }
                    { showModalConfirmAddIO &&
                    <ModalConfirmUserInformation
                        onClickCancelUserInformation={this.onClickCancelAddIOs}
                        // onClickConfirmUserInformation={this.onClickConfirmAddIOs}
                    />
                    }
                            <div className="col-md-12 table-responsive">
                                <div style={{textAlign:'right'}}>
                                <button className="btn btn-info btn-xs" onClick={() => this.onClickAddIO()} ><span className="fa fa-plus" /></button>
                                </div>
                                <table  className="table table-bordred table-striped table-hover ">
                                <thead >
                                    <tr>
                                    <th>#</th>
                                    <th style={{minWidth:120}}>Port</th>
                                    <th style={{minWidth:120}}>ชื่อ</th>
                                    <th style={{minWidth:120}}>ค่า 0 ชื่อ</th>
                                    <th style={{minWidth:120}}>คำสั่ง</th>
                                    <th style={{minWidth:120}}>ค่า 1 ชื่อ</th>
                                    <th style={{minWidth:120}}>คำสั่ง</th>
                                    <th></th>
                                    </tr></thead>
                                <tbody>
                                {
                                    inputOutputList.map((inOut,key) => {
                                        let typeNo = inOut.port_type+' '+inOut.port_no;
                                        return(
                                            <tr key={key}>
                                                <td>{key+1}</td>
                                                <td>
                                                    <select
                                                        name="port"
                                                        className="form-control"
                                                        defaultValue={typeNo}
                                                        onChange={(e) => this.onChangeSelectedPort(e, key)}>
                                                            {
                                                            portList.map((item,key) => {
                                                                return(
                                                                    <option id={`port_${key}`}
                                                                            key={key}
                                                                            selected={typeNo === item.porTypeNo}
                                                                            value={item.portTypeList+' '+item.portNo}>
                                                                        {item.portTypeList} {item.portNo}
                                                                    </option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </td>
                                                <td>
                                                <input
                                                    style={{background: 'rgba(255,255,255,0.4)',
                                                        border:'none'}}
                                                    name="name"
                                                    className="form-control"
                                                    type="text"
                                                    defaultValue={inOut.name}
                                                    // defaultValue={inOut[key].name}
                                                    onChange={(e) => this.onChangeSelectedPort(e, key)}
                                                />
                                                </td>
                                                <td>
                                                    <input
                                                        style={{background: 'rgba(255,255,255,0.4)',
                                                        border:'none'}}
                                                        className="form-control"
                                                        type="text"
                                                        name="val_name0"
                                                        defaultValue={inOut.val_name0}
                                                        // defaultValue={inOut[key].val_name0}
                                                        onChange={(e) => this.onChangeSelectedPort(e, key)}
                                                    />
                                                </td>
                                                <td>
                                                    <select
                                                        name="command_id0"
                                                        className="form-control"
                                                        defaultValue={inOut.command_id0}
                                                        // defaultValue={inOut[key].command_id0}
                                                        onChange={(e) => this.onChangeSelectedCommand(e, key)}>
                                                            {
                                                            commandList.map((item,key) => {
                                                                return(
                                                                    <option id={`command_id0_${key}`}
                                                                            key={key}
                                                                            selected={inOut.command_id0 === item.command_id}
                                                                            value={item.command_id}>
                                                                        {item.command_name}
                                                                    </option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </td>
                                                <td>
                                                    <input
                                                        style={{background: 'rgba(255,255,255,0.4)',
                                                        border:'none'}}
                                                        className="form-control"
                                                        type="text"
                                                        name="val_name1"
                                                        defaultValue={inOut.val_name1}
                                                        // defaultValue={inOut[key].val_name1}
                                                        onChange={(e) => this.onChangeSelectedPort(e, key)}
                                                    />
                                                </td>
                                                <td>
                                                    <select
                                                        name="command_id1"
                                                        className="form-control"
                                                        defaultValue={inOut.command_id1}
                                                        // defaultValue={inOut[key].command_id1}
                                                        onChange={(e) => this.onChangeSelectedCommand(e, key)}>
                                                            {
                                                            commandList.map((item,key) => {
                                                                return(
                                                                    <option id={`command_id1_${key}`}
                                                                            key={key}
                                                                            selected={inOut.command_id1 === item.command_id}
                                                                            value={item.command_id}>
                                                                        {item.command_name}
                                                                    </option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </td>
                                                <td style={{textAlign:'right'}}>
                                                    <p data-placement="top"  title="Delete">
                                                        <button
                                                            className="btn btn-danger btn-xs"
                                                            onClick={() => this.onClickDeleteRowIO(key)}>
                                                        <span className="fa fa-trash" />
                                                        </button>
                                                    </p>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                                </table>
                                <div className="text-right">
                                <button type="button" className="btn btn-primary" onClick={() => this.onClickSubmitIO()}>บันทึกข้อมูล</button>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
        );
    }
}

InputOutputDevice.defaultProps = {
    inputOutputs: []
}

InputOutputDevice.PropTypes = {
    inputOutputs: PropTypes.object,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    user_ids: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
}

export default InputOutputDevice;



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/InputOutputDevice.js